import React from "react";
import { SelectFilter } from "../search/SelectFilter";
import { LeftSearchMenuPiece } from "../search/LeftSearchMenuPiece";
import { getSuppliersByCriteria } from '../services/search.service';
import { FILTER_VARIANTS, FILTER_TITLES, FILTER_ID } from '../utils/surveyLiterals';

export const SupplierFilterNonDeere = ({ setNonDeereSupplierSelected, abortControllerRef }) => {
  const handleSupplierSelection = (event) => {
    if (event) setNonDeereSupplierSelected(event.value);
    else setNonDeereSupplierSelected(null);
  };

  return (
    <LeftSearchMenuPiece>
      <LeftSearchMenuPiece.Item id={FILTER_ID.NONDEERESUPPLIER} title={FILTER_TITLES.NONDEERESUPPLIER}>
        <SelectFilter loadOptionsFunction={getSuppliersByCriteria} onChange={handleSupplierSelection} variant={FILTER_VARIANTS.NONDEERESUPPLIER} abortControllerRef={abortControllerRef}/>
      </LeftSearchMenuPiece.Item>
    </LeftSearchMenuPiece>
  );
};